'use client';

import type { LinkProps } from '@coolblue-development/freddy';
import { Link } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

interface SpecificationLinkProps extends LinkProps {
  component: string;
}

const SpecificationLink = styled(Link)<SpecificationLinkProps>`
  color: ${({ theme }) => theme.color.font.additional};
  cursor: pointer;
  text-align: left;
  text-decoration: underline dashed ${({ theme }) => theme.color.font.additional};
  text-underline-offset: 4px;

  &:hover {
    border-bottom: 1px solid ${({ theme }) => theme.color.font.additional};
    text-decoration: none;
  }
`;

export default SpecificationLink;
